import React from 'react';
import styled from '@emotion/styled';
import NoAgentIcon from 'assets/svg/no-ava-ic.svg';
import NoOfficeIcon from 'assets/svg/agency-empty-avatar.svg';
import { Route, useRoute } from 'config/routes';

const NoOfficeWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
`;

export const NoImg: React.FC<{ size: number }> = ({ size }) => {
  const { route: { name } } = useRoute();
  return name === Route.OfficePage ? (
    <NoOfficeWrapper><NoOfficeIcon width={size} height={size} /></NoOfficeWrapper>
  ) : (
    <NoAgentIcon width={size} height={size} />
  );
};
